// ProjectActivityList — the project-scoped activity feed rows shared by the
// Overview Activity card (ProjectActivityCard) and the Activity tab
// (ProjectActivity): circular module-icon tile, "Actor verb Target" line and
// the full timestamp. Purely presentational — each surface owns its own query,
// states and card shell. Derivations come from the activity-log module so all
// activity surfaces render from one source.

import { useTranslation } from 'react-i18next';
import { Icon } from '@/components/common';
import type { ActivityItem } from '@/api/endpoints/activityLogApi';
import {
  ACTION_META,
  MODULE_ICONS,
  fmtFullDateTime,
  targetCode,
  targetName,
} from '@/pages/activity-log-page/activityMeta';

interface ProjectActivityListProps {
  items: ActivityItem[];
}

const ProjectActivityList = ({ items }: ProjectActivityListProps) => {
  const { t } = useTranslation();

  return (
    <ul className='project-detail__activity'>
      {items.map((a) => {
        const name = targetName(a);
        const target =
          a.entityReferenceNumber != null
            ? `${targetCode(a.module, String(a.entityReferenceNumber), name)} · ${name}`
            : name;
        return (
          <li key={a.id} className='project-detail__activity-row'>
            <span className='project-detail__activity-tile' aria-hidden='true'>
              <Icon name={MODULE_ICONS[a.module] ?? 'scroll-text'} size={16} />
            </span>
            <span className='project-detail__activity-text'>
              <span className='project-detail__activity-line'>
                <b className='project-detail__activity-actor'>{a.user?.fullName ?? '—'}</b>{' '}
                <span className='project-detail__activity-verb'>
                  {t(ACTION_META[a.action].labelKey)}
                </span>{' '}
                {target}
              </span>
              <span className='project-detail__activity-time'>{fmtFullDateTime(a.createdAt)}</span>
            </span>
          </li>
        );
      })}
    </ul>
  );
};

export default ProjectActivityList;
